module.exports = __webpack_public_path__ + "static/media/user_help.533c3a0e.svg";